module.exports = {"360982001":"淦阳街道","360982002":"鹿江街道","360982003":"福城街道","360982004":"大桥街道","360982005":"张家山街道","360982100":"临江镇","360982101":"永泰镇","360982102":"黄土岗镇","360982103":"经楼镇","360982104":"昌傅镇","360982105":"店下镇","360982106":"阁山镇","360982107":"刘公庙镇","360982108":"观上镇","360982109":"义成镇","360982200":"中洲乡","360982201":"洲上乡","360982202":"洋湖乡","360982203":"吴城乡","360982400":"樟树市工业园区","360982401":"滨江新城","360982500":"省双金园艺场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360982.json
// module id = 1325
// module chunks = 0